/* */ 
'use strict';
var AlgoliaSearchCore = require('../../AlgoliaSearchCore');
var createAlgoliasearch = require('../createAlgoliasearch');
module.exports = createAlgoliasearch(AlgoliaSearchCore, '(lite) ');
